type Asset = {
    mimeType: string;
}

type MimeTypePrefix = typeof MIME_PREFIXES[keyof typeof MIME_PREFIXES];
type MimeType = string;

const MIME_PREFIXES = {
    IMAGE: 'image/',
    VIDEO: 'video/',
    AUDIO: 'audio/',
    APPLICATION: 'application/',
};

/**
 * Returns function that checks if asset has one of the associated mime types.
 *
 * @param {Array} mimeTypes array of mime types without prefix
 * @param {string} prefix prefix for passed mime types
 * @returns {Function} function that checks if asset has one of the mime types
 * @throws {Error} if prefix is not supported
 */
function getMimeTypeChecker(mimeTypes: MimeType[], prefix: MimeTypePrefix) {
    if (!prefix?.length) {
        logger.warn('Prefix is not provided');
    }

    if (!Object.values(MIME_PREFIXES).includes(prefix)) {
        logger.warn(`Prefix ${prefix} is not supported`);
    }

    const mimeTypesToCheck = mimeTypes?.length ? mimeTypes : [];

    return (asset: Asset): boolean => {
        if (!asset || !asset.mimeType) {
            return false;
        }

        const { mimeType } = asset;
        const mimeTypeWithPrefix = `${prefix}${mimeType}`;

        return mimeTypesToCheck.includes(mimeType) || mimeTypesToCheck.includes(mimeTypeWithPrefix);
    };
}

export const hasImageMimeType = (mimeTypes) => getMimeTypeChecker(mimeTypes, MIME_PREFIXES.IMAGE);
export const hasVideoMimeType = (mimeTypes) => getMimeTypeChecker(mimeTypes, MIME_PREFIXES.VIDEO);
export const hasAudioMimeType = (mimeTypes) => getMimeTypeChecker(mimeTypes, MIME_PREFIXES.AUDIO);
export const hasApplicationMimeType = (mimeTypes) => getMimeTypeChecker(mimeTypes, MIME_PREFIXES.APPLICATION);